import React, { useContext } from 'react'
import './home.scss'
import { deleteDoc, doc } from 'firebase/firestore';
import { db } from '../../firebase';
import Sidebar from '../../components/sidebar/Sidebar';
import Navbar from '../../components/navbar/Navbar';
import { useMediaQuery, useTheme } from '@material-ui/core';
import { DataGrid } from '@mui/x-data-grid';
import { UserContext } from '../../Contexts/UserContext';
import { useNavigate } from 'react-router-dom';
import { CustomCell, useStyles } from '../../helperFunctions';

const Home = () => {
    const { ticketData, setTicketData, loggedUser } = useContext(UserContext);
    const loggedUserTickets = ticketData?.filter((tickets) => tickets.assignee?.id === loggedUser?.id)
    const sortedTicket = [...ticketData].sort((a, b) => b.timeStamp - a.timeStamp);
    const navigate = useNavigate();

    const deleteTicket = async (id) => {
        try {
            await deleteDoc(doc(db, "invoices", id));
            setTicketData(ticketData.filter((item) => item.id !== id));
        } catch (err) {
            console.log(err);
        }
    };


    const ticketColumns = [
        { field: "subject", headerName: "Subject", flex: 0.7 },
        { field: "reporter", headerName: "Reporter", flex: 0.5 },
        {
            field: "timeStamp",
            headerName: "Date",
            flex: 0.5,
            valueFormatter: (params) => {
                const date = params.value?.toDate().toDateString();
                return date || "";
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            flex: 0.5,
            renderCell: (params) => {
                return <CustomCell value={params.value}>{params.value}</CustomCell>;
            },
        },
        {
            field: "assignee",
            headerName: "Assignee",
            flex: 0.5,
            renderCell: (params) => {
                return params.row.assignee?.fullname || "";
            }
        },
        {
            field: "action",
            headerName: "Action",
            flex: 0.8,
            renderCell: (params) => {
                return (
                    <div className="actionButtons">
                        <button
                            onClick={() => navigate(`/tickets/${params.row.id}`)}
                            className="greenButton"
                        >
                            View
                        </button>
                        <button
                            onClick={() => deleteTicket(params.row.id)}
                            className="redButton"
                        >
                            Delete
                        </button>
                    </div>
                );
            }
        }
    ];


    const classes = useStyles();
    const theme = useTheme();
    const isPhoneScreen = useMediaQuery(theme.breakpoints.down("xs"));
    const isTabletScreen = useMediaQuery(theme.breakpoints.down("sm"));
    const isDesktopScreen = useMediaQuery(theme.breakpoints.down("md"));




    let columns = [...ticketColumns]
    if (isPhoneScreen) {
        columns = ticketColumns.filter(
            (column) => column.field !== 'reporter' && column.field !== 'timeStamp' && column.field !== 'assignee' && column.field !== 'status'
        )
    } else if (isTabletScreen) {
        columns = ticketColumns.filter(
            (column) => column.field !== 'reporter' && column.field !== 'timeStamp'
        )
    } else if (isDesktopScreen) {
        columns = ticketColumns.filter(
            (column) => column.field !== 'timeStamp'
        )
    }


    const columnsWithHeaderStyle = columns.map((column) => ({
        ...column,
        headerClassName: classes.headerCell,
    }));


    return (
        <>
            <div className="container">
                <Sidebar />
                <div className="invoiceContainer">
                    <Navbar />
                    <div className="homeContainer">
                        <div className="activityContainer">
                            <h2>Recent Activities</h2>
                            {sortedTicket?.map((ticket) => {
                                return (
                                    <div key={ticket.id}>
                                        <p>{ticket.reporter} created ticket <span className="ticketSubject" onClick={() => navigate(`/tickets/${ticket.id}`)}>{ticket.subject}</span> on<span className="date"> {ticket.timeStamp?.toDate().toDateString()}</span></p>
                                    </div>
                                )
                            })}
                        </div>
                    </div>
                    <div className="tableContainer">
                        <div className="header">
                            <h2>Assigned Tickets</h2>
                            <button onClick={() => navigate("/tickets/add")} className="button">Add Tickets</button>
                        </div>
                        <div className={classes.datatable}>
                            <DataGrid
                                className={classes.datatable}
                                rows={loggedUserTickets}
                                columns={columnsWithHeaderStyle}
                                pageSize={5}
                                rowsPerPageOptions={[5]}
                                disableSelectionOnClick
                            />
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Home